<template>
  <div class="mb-4" v-if="sfdcSearchEnabled()">

    <div class="stage-header mb-4">

      <b-tabs pills card>
        <b-tab title="Opportunity">
          <div v-if="sfdc_opp_loading">
            <div class="caption-label-hide d-flex">
              <div>
                <i v-if="sfdc_opp_loading" style="color: #f77530;" class="fa fa-circle-o-notch fa-spin fa-fw"> </i>
                Salesforce Opportunity
              </div>
            </div>
          </div>

          <div v-else>
            <div class="caption-label">
              Salesforce Opportunity
            </div>
            <div class="row border-bottom mb-4">
              <div class="col-12">
                <div class="header-col">
                  <div>Opportunity Name</div>
                  <gtc-opportunity v-if=" sf_opty_info!= null" :opportunityId="sf_opty_info.ID"
                                   :opportunityName="sf_opty_info.NAME"
                                   v-b-tooltip.hover.right :title="linkHoverInfo('Opportunity')" />
                </div>
              </div>
              <div class="col-12">
                <div class="header-col">
                  <div>Opportunity Number</div>
                  <div>{{ _.get(sf_opty_info, 'OPPORTUNITY_NUMBER__C', '') }} </div>
                </div>
              </div>
              <div class="col-12">
                <div class="header-col">
                  <div>Account Name</div>
                  <div><a class="link" target="_blank" :href="safeUrl(`${ frontEndUrlToUse }opportunity/account-id/${_.get(sf_opty_info, 'ACCOUNTID', '') }`)">{{ _.get(sf_opty_info, 'ACCOUNT_NAME', '') }}</a> </div>

                </div>
              </div>

              <!-- 1---------------------------------------------------------->
              <div class="col-4">
                <div class="header-col">
                  <div>Opportunity Owner</div>
                  <div>{{ _.get(sf_opty_info, 'OWNER_NAME', '') }} </div>
                </div>
                <div class="header-col">
                  <div>Create By</div>
                  <div>{{ _.get(sf_opty_info, 'CREATEDBY_NAME', '') }} </div>
                </div>
                <div class="header-col">
                  <div>Key Opportunity</div>
                  <div>{{ _.get(sf_opty_info, 'KEY_OPPORTUNITY__C', '') }}</div>
                </div>
                <div class="header-col">
                  <div>Global Enterprise Opportunity</div>
                  <div>{{ _.get(sf_opty_info, 'GLOBAL_ENTERPRISE_OPPORTUNITY__C', '') }}</div>
                </div>

                <div class="header-col">
                  <div>Video Bussiness</div>
                  <div>{{ _.get(sf_opty_info, 'VIDEO_BUSINESS__C', '') }}</div>
                </div>

                <div class="header-col">
                  <div>Status</div>
                  <div>{{ _.get(sf_opty_info, 'STATUS__C', '') }}</div>
                </div>

                <div class="header-col">
                  <div>Stage</div>
                  <div>{{ _.get(sf_opty_info, 'STAGENAME', '') }}</div>
                </div>
                <div class="header-col">
                  <div>Probability (%)</div>
                  <div>{{ _.get(sf_opty_info, 'PROBABILITY', '') }}</div>
                </div>
              </div>

              <!-- 2---------------------------------------------------------->
              <div class="col-4">
                <div class="header-col">
                  <div>Type</div>
                  <div>{{ _.get(sf_opty_info, 'TYPE', '') }} </div>
                </div>
                <div class="header-col">
                  <div>
                    Classification
                  </div>
                  <div>{{ _.get(sf_opty_info, 'CLASSIFICATION__C', '') }}</div>
                </div>
                <div class="header-col">
                  <div>
                    Close Date
                  </div>
                  <div>{{ _.get(sf_opty_info, 'CLOSEDATE', '') }} </div>
                </div>
                <div class="header-col">
                  <div>Close Reason</div>
                  <div>{{ _.get(sf_opty_info, 'CLOSE_REASON__C', '') }}</div>
                </div>
                <div class="header-col">
                  <div>
                    Loss Reason
                  </div>
                  <div>{{ _.get(sf_opty_info, 'LOSS_REASON__C', '') }}</div>
                </div>

                <div class="header-col">
                  <div>
                    Technical Stage
                  </div>
                  <div>{{ _.get(sf_opty_info, 'TECHNICAL_STAGE__C', '') }}</div>
                </div>

                <div class="header-col">
                  <div>
                    Must Win
                  </div>
                  <div>{{ _.get(sf_opty_info, 'MUST_WIN__C', '') }}</div>
                </div>
                <div class="header-col">
                  <div>
                    Must Win Type
                  </div>
                  <div>{{ _.get(sf_opty_info, 'MUST_WIN_TYPE__C', '') }}</div>
                </div>
              </div>

              <!-- 0---------------------------------------------------------->


              <div class="col-4">

                <div class="header-col">
                  <div>Country</div>
                  <div>{{ _.get(sf_opty_info, 'ACCOUNT_COUNTRY__C', '') }}</div>
                </div>

                <div class="header-col">
                  <div>Opportunity Currency</div>
                  <div>{{_.get(sf_opty_info, 'CURRENCYISOCODE', '') }}</div>
                </div>


                <div class="header-col">
                  <div>Primary Sales Contact</div>
                  <div>{{_.get(sf_opty_info, 'ACCOUNT_PRIMARY_SALES_CONTACT__C', '') }}</div>
                </div>

                <div class="header-col">
                  <div>
                    Primary Tech Contact
                  </div>
                  <div>{{_.get(sf_opty_info, 'ACCOUNT_PRIMARY_TECHNICAL_CONTACT__C', '') }}</div>
                </div>
                <div class="header-col">
                  <div>Lead Source</div>
                  <div>{{ _.get(sf_opty_info, 'LEADSOURCE', '') }}</div>
                </div>
                <div class="header-col">
                  <div>Industry</div>
                  <div>{{ _.get(sf_opty_info, 'VERTICAL_INDUSTRY__C', '') }}</div>
                </div>
                <div class="header-col">
                  <div>Vertical</div>
                  <div>{{ _.get(sf_opty_info, 'SUB_VERTICAL_INDUSTRY__C', '') }}</div>
                </div>

              </div>

              <div class="col-12">
                <div class="header-col">
                  <div>Customer Comments</div>
                  <div>{{ _.get(sf_opty_info, 'CUSTOMER_COMMENTS__C', '') }}</div>
                </div>
              </div>
              <div class="col-12">
                <!-- PERSONAL_NOTES__C -->
                <div class="header-col">
                  <div>Personal Notes</div>
                  <button type="button"
                          class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                          v-b-tooltip.hover.topleft
                          title="Store any personal notes here, such as meeting minutes or for making a quick note outside of updating the 'Latest Update Information'."></button>
                  <div v-if="sf_opty_info != null" v-html="sf_opty_info.PERSONAL_NOTES__C"></div>
                </div>
              </div>
              <div class="col-12">
                <div class="header-col">
                  <div>Latest Update Info</div>
                  <div v-if="sf_opty_info != null" v-html="sf_opty_info.LATESTINFORMATION__C"></div>
                </div>
              </div>
              <!-- Region:AI Summary Button -->
              <!--
                  <div class="col-12" v-if="!prdEnv() && sf_opty_info !== null && sf_opty_info.LATESTINFORMATION__C !== null">
                    <b-dropdown id="dropdown-text"
                                size="lg" variant="link"
                                @show="getAISummary(sf_opty_info.LATESTINFORMATION__C, 'Latest Update Info')"
                                toggle-class="text-decoration-none" no-caret>
                      <template #button-content>
                        &#x1f50d;
                        <span class="sr-only">AI Summary</span>
                      </template>
                      <b-dropdown-text style="width: 240px;">
                        {{ai_response}}
                      </b-dropdown-text>
                      <b-dropdown-text>And this is more example text.</b-dropdown-text>
                    </b-dropdown>
                    <div v-if="!prdEnv() && ai_response !== null">
                      <b-alert show variant="success">
                        <div v-if="ai_response != null"
                             v-html="safeHtml(ai_response)"></div>
                      </b-alert>
                  </div>
                  </div> -->
              <!-- end region -->
            </div>
          </div>

          <!-- region: Revenue Summary-->
          <div class="caption-label-hide d-flex">
            <div class="caption-label">
              Revenue Summary
            </div>
            <div>
              <b-button v-b-toggle.collapseRevSummary
                        variant="outline-primary"
                        class="text-primary text-left"
                        style="background-color: white; border: none; padding-left: 40px;">
                <b-icon :icon="isCollapsedRev ? 'chevron-down' : 'chevron-up'"></b-icon>
              </b-button>
            </div>
          </div>
          <b-collapse id="collapseRevSummary" @shown="onShownRev"
                      @hidden="onHiddenRev" accordion="Revenue Summary"
                      role="tabpanel">
            <div style="padding-top: 10px; padding-left: 16px;"
                 class="border-bottom"
                 v-if="sf_opty_info">
              <div class="row mb-4">
                <div class="col-6">
                  <div class="header-col">
                    <div style="width: 40%;">Total Qty</div>
                    <gtc-number :read-only="readOnlyFlag" v-model="_.get(sf_opty_info, 'TOTAL_QTY__C', '')"></gtc-number>
                    <!--<div> {{ _.get(sf_opty_info, 'TOTAL_QTY__C', '') }} </div> -->
                  </div>
                  <div class="header-col">
                    <div style="width: 40%;">Committed Qty</div>
                    <gtc-number :read-only="readOnlyFlag" v-model="_.get(sf_opty_info, 'COMMITTED_QTY__C', '')"></gtc-number>
                  </div>
                  <div class="header-col">
                    <div style="width: 40%;">Total Qty - System</div>
                    <gtc-number :read-only="readOnlyFlag" v-model="_.get(sf_opty_info, 'REVSUM_TOTAL_QTY_SYSTEM__C', '')"></gtc-number>
                  </div>
                  <div class="header-col">
                    <div style="width: 40%;">Total Qty - Non-System</div>
                    <gtc-number :read-only="readOnlyFlag" v-model="_.get(sf_opty_info, 'REVSUM_TOTAL_QTY_NON_SYSTEM__C', '')"></gtc-number>

                  </div>
                </div>

                <!-- col #2 -->
                <div class="col-6">
                  <div class="header-col">
                    <div style="width: 40%;">Amount ({{_.get(sf_opty_info, 'CURRENCYISOCODE', '') }})</div> <!-- no Amount fields-->
                    <gtc-number :read-only="readOnlyFlag" v-model="_.get(sf_opty_info, 'AMOUNT', '')"></gtc-number>
                    <!-- <div> {{ _.get(sf_opty_info, 'AMOUNT', '') }}  </div>-->
                  </div>
                  <div class="header-col">
                    <div style="width: 40%;">Committed Amount ({{_.get(sf_opty_info, 'CURRENCYISOCODE', '') }})</div>
                    <gtc-number :read-only="readOnlyFlag" v-model="_.get(sf_opty_info, 'COMMITTED_AMOUNT__C', '')"></gtc-number>
                  </div>
                  <div class="header-col">
                    <div style="width: 40%;">Total Revenue - System ({{_.get(sf_opty_info, 'CURRENCYISOCODE', '') }})</div>
                    <gtc-number :read-only="readOnlyFlag" v-model="_.get(sf_opty_info, 'REVSUM_TOTAL_REV_SYSTEM__C', '')"></gtc-number>
                  </div>
                  <div class="header-col">
                    <div style="width: 40%;">Total Revenue - Non-System ({{_.get(sf_opty_info, 'CURRENCYISOCODE', '') }})</div>
                    <gtc-number :read-only="readOnlyFlag" v-model="_.get(sf_opty_info, 'REVSUM_TOTAL_REV_NON_SYSTEM__C', '')"></gtc-number>
                  </div>
                </div>
                <!-- end of col #2-->
              </div>
              <div class="row mb-4">
                <div class="col-6">
                  <div class="header-col">
                    <div style="width: 40%;">Total Deployed Qty</div>
                    <gtc-number :read-only="readOnlyFlag" v-model="_.get(sf_opty_info, 'REVSUM_TOTAL_DEPLOYED_QTY__C', '')"></gtc-number>
                  </div>
                  <div class="header-col">
                    <div style="width: 40%;">Total Deployed Qty - System</div>
                    <gtc-number :read-only="readOnlyFlag" v-model="_.get(sf_opty_info, 'REVSUM_TOTAL_DEPLOYED_QTY_SYSTEM__C', '')"></gtc-number>
                  </div>

                  <div class="header-col">
                    <div style="width: 40%;">Total Deployed Qty - Non-System</div>
                    <gtc-number :read-only="readOnlyFlag" v-model="_.get(sf_opty_info, 'REVSUM_TOTAL_MPSED_QTY_NON_SYSTEM__C', '')"></gtc-number>
                  </div>
                  <div class="header-col">
                    <div style="width: 40%;">Total MPSed Qty - System</div>
                    <gtc-number :read-only="readOnlyFlag" v-model="_.get(sf_opty_info, 'REVSUM_TOTAL_MPSED_QTY_SYSTEM__C', '')"></gtc-number>
                  </div>
                </div>

                <!-- col #2 -->
                <div class="col-6">
                  <div class="header-col">
                    <div style="width: 40%;">Total Deployed Revenue ({{_.get(sf_opty_info, 'CURRENCYISOCODE', '') }})</div> <!-- no Amount fields-->
                    <gtc-number :read-only="readOnlyFlag" v-model="_.get(sf_opty_info, 'REVSUM_TOTAL_DEPLOYED_REVENUE__C', '')"></gtc-number>
                  </div>
                  <div class="header-col">
                    <div style="width: 40%;">
                      Total Deployed Revenue - System ({{_.get(sf_opty_info, 'CURRENCYISOCODE', '') }})
                    </div>
                    <gtc-number :read-only="readOnlyFlag" v-model="_.get(sf_opty_info, 'REVSUM_TOTAL_DEPLOYED_REVENUE_SYSTEM__C', '')"></gtc-number>

                  </div>
                  <div class="header-col">
                    <div style="width: 40%;">Total Deployed Revenue - Non-System ({{_.get(sf_opty_info, 'CURRENCYISOCODE', '') }})</div>
                    <gtc-number :read-only="readOnlyFlag" v-model="_.get(sf_opty_info, 'REVSUM_TOTAL_DEPLOYED_REVENUE_NON_SYSTEM__C', '')"></gtc-number>
                  </div>
                  <div class="header-col">
                    <div style="width: 40%;">Total MPSed Qty - Non-System</div>
                    <gtc-number :read-only="readOnlyFlag" v-model="_.get(sf_opty_info, 'REVSUM_TOTAL_MPSED_QTY_SYSTEM__C', '')"></gtc-number>


                  </div>
                </div>
                <!-- end of col #2-->
              </div>
            </div>

          </b-collapse>
          <!-- end region-->
          <!-- region: SKU PN Loader -->

          <br />
          <div v-if="sfdc_prd_line_loading" class="caption-label-hide d-flex">
            <div class="caption-label">
              <i v-if="sfdc_prd_line_loading" style="color: #f77530;" class="fa fa-circle-o-notch fa-spin fa-fw"> </i>
              Salesforce Product
            </div>
          </div>

          <div v-else style="padding-left: 17px;">


            <sfdc-prd-line-view-only v-if="sfdcProducts!=null && sfdcSearchEnabled()"
                                     :prop_sfdc_page_obj="sfdcProducts"
                                     :prop_user="login_user_name"
                                     :prop_user_sites="userSites" />
          </div>
          <!-- endregion -->
          <!-- region ES List-->
          <div v-if="sfdc_es_loading" class="caption-label-hide d-flex">
            <div class="caption-label">
              <i v-if="sfdc_es_loading" style="color: #f77530;" class="fa fa-circle-o-notch fa-spin fa-fw"> </i>
              Engineering Services
            </div>
          </div>

          <div v-else style="padding-left: 17px;">
            <sfdc-engineering-services v-if="sf_es_list!=null && sfdcSearchEnabled()"
                                       :prop_sfdc_es="sf_es_list"
                                       :prop_opp_id="opty_id"
                                       :prop_user="login_user_name"
                                       :prop_user_sites="userSites" />
          </div>


          <!-- endregion -->
          <!-- region: Demo Loans Loader -->

          <div v-if="sfdc_demo_loans_loading" class="caption-label-hide d-flex">
            <div class="caption-label">
              <i v-if="sfdc_demo_loans_loading" style="color: #f77530;" class="fa fa-circle-o-notch fa-spin fa-fw"> </i>
              Salesforce Demo Loans
            </div>
          </div>

          <div v-else style="padding-left: 17px;">
            <sfdc-demo-loans v-if="sf_demo_loans!=null && sfdcSearchEnabled()"
                             :prop_sfdc_demo_loans="sf_demo_loans"
                             :prop_user="login_user_name"
                             :prop_user_sites="userSites" />
          </div>
          <!-- endregion -->

        </b-tab>
        <!-- region: Salesforce Account Tab -->
        <b-tab v-if="sf_opty_info !=null && _.get(sf_opty_info, 'ACCOUNTID', '') != null && _.get(sf_opty_info, 'ACCOUNTID', '') != ''"
               title="Account" @click="getAccountInfo">
          <div v-if="sfdc_account_loading" class="caption-label-hide d-flex">
            <div>
              <i v-if="sfdc_account_loading" style="color: #f77530;" class="fa fa-circle-o-notch fa-spin fa-fw"> </i>
              Salesforce Account
            </div>
          </div>

          <div v-else>
            <account-page v-if="sf_account_info!=null && sfdcSearchEnabled()"
                          :prop_account_page_obj="sf_account_info"
                          :prop_user_sites="userSites"
                          :prop_user="login_user_name"
                          :prop_user_functions="userFunctions"
                          :prop_user_roles="userRoles" />
          </div>
        </b-tab>
        <!-- endregion -->
      </b-tabs>
    </div>

    </div>
</template>
<script>
  import * as moment from 'moment/moment';
  import { safeUrl } from '@/helpers/vue-url';
  import { safeHtml } from '@/helpers/vue-safehtml';
  export default {
    name: 'opty-page',
    data() {
      return {
        function_name: 'Opty Page',
        sf_opty_info: null,
        sf_account_info: null,
        sf_demo_loans: null,
        sf_es_list: null,
        opty_id: encodeURIComponent(this.$route.params.opty_id),
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        searching: false,
        sfdcProducts: null,
        sfdc_prd_line_loading: true,
        sfdc_account_loading: true,
        sfdc_demo_loans_loading: true,
        sfdc_es_loading: true,
        sfdc_opp_loading: true,
        userFunctions: null,
        userRoles: null,
        userSites: null,
        login_user_name: null,
        // isCollapsed: true,
        isCollapsedRev: true,
        // isCollapsedProduct: true,
        readOnlyFlag: true,
        ai_response: null,
      };
    },
    created() {
      let self = this;
      self.checkLoggedIn();
      if (self.sfdcSearchEnabled()) {
        self.getOptyInfo();
      } else {
        this.$message.error(`You do not have permissions to access Salesforce Opportunity Information.\nPlease contact FTIE system administrators.`);
      }

    },
    computed: {
      /*
      videoBizDisplay() {
        let self = this;
        if (_.get(self.sf_opty_info, 'VIDEO_BUSINESS__C', '') || _.get(self.sf_opty_info, 'VIDEO_BUSINESS__C', true)) {
          return 'Yes'
        }
        return 'No'
      },
      */

    },
    methods: {
      prdEnv() {
        return 'PRD' === this.$session.get('mode');
      },

      linkHoverInfo(linkTo) {
        return `View Salesforce ${linkTo} Page (Permission Required)`;
      },

      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');

        this.login_user_name = user_name

        this.userFunctions = user_functions;
        this.userRoles = user_roles;
        this.userSites = user_site;
        this.sfdcSearchEnabled();

      },

      classObject(input, maxLength) {
        return {
          'text-danger': this.$options.filters['reachLength'](input, maxLength),
          'text-success': !this.$options.filters['reachLength'](input, maxLength),
          'text-weight': this.$options.filters['reachLength'](input, maxLength) ? 'bold' : 'normal'//,
        }
      },

      isShowingCollapseFunc(accordionId) {
        let self = this;
        return _.get(self.isShowingCollapse, accordionId, false);
      },

      // Toggle Both Collapse A and B (by IDS list)
      toggleCollapses(ids) {
        ids.forEach((id) => {
          this.$root.$emit('bv::toggle::collapse', id)
        })
      },

      globalSearchEnable() {
        let self = this;
        if ((self.userRoles && (_.indexOf(self.userRoles, 'Admin') > -1 || _.indexOf(self.userRoles, 'ES_PM_Leader') > -1)) || (self.userFunctions && (_.indexOf(self.userFunctions, 'Customer Success Manager') > -1))
        ) {
          console.log("Search Enabled!!");
          return true
        } else {
          console.log("Search Disabled!!");
          return false;
        }

      },
      sfdcSearchEnabled() {
        let self = this;
        if ((self.userRoles && (_.indexOf(self.userRoles, 'Admin') > -1 || (_.indexOf(self.userRoles, 'ES_PM_Leader') > -1 && self.userSites && _.indexOf(self.userSites, 'Getac') > -1)) || (self.userFunctions && _.indexOf(self.userFunctions, 'Customer Success Manager') > -1))
        ) {
          console.log("Search Enabled!!");
          return true
        }
        if (((self.userSites && _.indexOf(self.userSites, 'GUSA') > -1 && self.userRoles && _.indexOf(self.userRoles, 'GRO_SA') > -1) && self.userRoles && (_.indexOf(self.userRoles, 'GRO_SA_Leader') > -1 || _.indexOf(self.userRoles, 'GRO_SA') > -1))) {
          console.log("Search Enabled!!");
          return true
        }
        console.log("Search Disabled!!");
        return false;
      },
      ifUserCanAccess() {
        let self = this;
        if (self.sfdcSearchEnabled()) {
          if ((self.userRoles && (_.indexOf(self.userRoles, 'Admin') > -1 || (_.indexOf(self.userRoles, 'ES_PM_Leader') > -1 && self.userSites && _.indexOf(self.userSites, 'Getac') > -1)) || (self.userFunctions && _.indexOf(self.userFunctions, 'Customer Success Manager') > -1))
          ) {
            return true
          }
          if (((self.userSites && _.indexOf(self.userSites, 'GUSA') > -1 && self.userRoles && _.indexOf(self.userRoles, 'GRO_SA') > -1) && self.userRoles && (_.indexOf(self.userRoles, 'GRO_SA_Leader') > -1 || _.indexOf(self.userRoles, 'GRO_SA') > -1)))
          {
            console.log("Can only view US opty for GUSA SA !!");
            if (_.get(self.sf_opty_info, 'OPPORTUNITY_NUMBER__C', '') !== null && _.get(self.sf_opty_info, 'OPPORTUNITY_NUMBER__C', '').includes("US")) {
              return true
            }
            else {
              return false
            }
          }
        }
        return false;
      },

      getOptyInfo() {
        // /opportunity/back-end/opty-id/<str:opty_id>
        let self = this;
        if (self.sfdcSearchEnabled()) {
          let requestData = {
            es_id: null,
            opty_id: self.opty_id,
            request_from: null
          };
          // self.searching = true;
          // eventHub.$emit('loading', true);
          self.sfdc_opp_loading = true;
          this.$axios
            .post(self.$root.baseUrl + '/opportunity/back-end/opty-id/' + self.opty_id, requestData)
            .then(res => {
              let result = res.data;

              if (_.get(result, 'opty_info', null) !== null) {
                self.sf_opty_info = JSON.parse(result.opty_info);
              }
            })
            .finally(() => {
              //eventHub.$emit('loading', false);
              self.sfdc_opp_loading = false;
              if (self.opty_id !== null && self.sf_opty_info !== null && self.ifUserCanAccess()) {
                //console.log("self.sf_opty_info");
                //console.log(self.sf_opty_info);
                self.getSfProductline();
                self.getDemoLoans();
                self.getEngineeringServices();
              } else {
                self.sf_opty_info = null;
                self.sfdc_prd_line_loading = false;
                self.sfdc_demo_loans_loading = false;
                self.sfdc_es_loading = false;
                this.$message.error(`You do not have permissions to access Salesforce Opportunity Information from this region.\nPlease contact FTIE system administrators.`);
              }
            });
        }


      },

      onTabChange(newIndex) {
        console.log("newIndex:" + newIndex);
        let self = this;
      },

      getAccountInfo() {
        let self = this;
        let requestData = {
          account_id: _.get(self.sf_opty_info, 'ACCOUNTID', ''),
         };
        /**
          if (self.sfdc_account_loading) {
          eventHub.$emit('loading', true);
        }
 */

        self.sfdc_account_loading = true;

        this.$axios.post(self.$root.baseUrl + '/opportunity/back-end/account-id/' + _.get(self.sf_opty_info, 'ACCOUNTID', ''), requestData)
          .then(res => {
            let result = res.data;
            if (_.get(result, 'account_info', null) !== null) {
              self.sf_account_info = JSON.parse(result.account_info);
            }
          })
          .finally(() => {
            self.sfdc_account_loading = false;
          });
      },

      onShownRev() {
        this.isCollapsedRev = false;
      },
      onHiddenRev() {
        this.isCollapsedRev = true;
      },

      getDemoLoans() {
        let self = this;
        let requestData = {
          account_id: _.get(self.sf_opty_info, 'ACCOUNTID', ''),
          opty_id: self.opty_id
         };
        /**
          if (self.sfdc_demo_loans_loading) {
          eventHub.$emit('loading', true);
        }
        */

        self.sfdc_demo_loans_loading = true;
        this.$axios.post(self.$root.baseUrl + '/opportunity/back-end/demo-loans/opty-id/' + _.get(self.sf_opty_info, 'ACCOUNTID', ''), requestData)
          .then(res => {
            let result = res.data;
            if (_.get(result, 'demo_loan_list', null) !== null) {
              self.sf_demo_loans = JSON.parse(result.demo_loan_list);
            }
          })
          .finally(() => {
            if (self.opty_id !== null) {
              console.log("self.sf_demo_loans");
              console.log(self.sf_demo_loans);
            }
            // eventHub.$emit('loading', false);
            self.sfdc_demo_loans_loading = false;
          });
      },

      getEngineeringServices() {
        let self = this;
        let requestData = {
          account_id: self.opty_id, //_.get(self.sf_opty_info, 'ACCOUNTID', ''),
          opty_id: self.opty_id
         };
        /**
          if (self.sfdc_es_loading) {
          eventHub.$emit('loading', true);
        }
        */

        self.sfdc_es_loading = true;
        this.$axios.post(self.$root.baseUrl + '/opportunity/back-end/engineering-services/parent-id/' + self.opty_id, requestData)
          .then(res => {
            let result = res.data;
            if (_.get(result, 'es_info_list', null) !== null) {
              self.sf_es_list = JSON.parse(result.es_info_list);
            }
          })
          .finally(() => {
            // eventHub.$emit('loading', false);
            self.sfdc_es_loading = false;
          });
      },

      getSfProductline() {
        let self = this;
        if (self.sfdcSearchEnabled()) {
          let requestData = {
            opty_id: self.opty_id,
            username: self.login_user_name,
           };
            /**
          self.searching = true;
          if (!self.sfdc_prd_line_loading) {
            eventHub.$emit('loading', true);
          }
 */

          self.sfdc_prd_line_loading = true;
          this.$axios
            .post(self.$root.baseUrl + '/opportunity/back-end/product-line/opty-id/' + self.opty_id, requestData)
            .then(res => {
              let result = res.data;
              if (_.get(result, 'sfdc_prd_line_info_list', null) !== null &&
                _.size(_.get(result, 'sfdc_prd_line_info_list', new Array())) > 0) {
                result.sfdc_prd_line_info_list = JSON.parse(result.sfdc_prd_line_info_list);
              }
              self.sfdcProducts = result.sfdc_prd_line_info_list

            })
            .finally(() => {
              // eventHub.$emit('loading', false);
              self.sfdc_prd_line_loading = false;
            });
        }
      },
      getAISummary(input_content, content_source_column) {
        let self = this;
        if (self.sfdcSearchEnabled()) {
          let requestData = {
            content: input_content,
            purpose: 'Summary',
            username: self.login_user_name,
            content_source: 'Salesforce',
            content_source_object: 'Opportunity',
            content_source_object_id: self.opty_id,
            content_source_column: content_source_column,
            llm_model: 'gemma3:27b'
          };

          let url = self.$root.baseUrl + '/ai-service/getac-ai/summary/response/'; // After H100 AI on-premise
          this.$axios
            .post(url, requestData)
            .then(res => {
              let result = res.data;
              if (_.get(result, 'html_response', null) !== null) {
                self.ai_response = result.html_response;
              }

            })
            .finally(() => {
              console.log("AI done")
            });
        }
      }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/opty-management/OptyPage.vue